<template>
  <div v-if="show">
    <div class="modal-overlay" @click.self="onClose">
      <div class="modal-card">
        <button class="close-icon" @click="onClose" aria-label="Close">
          <svg width="22" height="22" viewBox="0 0 24 24">
            <path d="M6 6L18 18M6 18L18 6" stroke="#333" stroke-width="2" stroke-linecap="round" />
          </svg>
        </button>
        <div class="modal-header">
          <h2 class="modal-title">Report Spam</h2>
        </div>
        <div class="details-row">
          <span class="label">Reason</span>
        </div>
        <textarea
          v-model="localReportText"
          class="report-textarea"
          placeholder="Describe why you think this is spam (required)"
          rows="4"
        ></textarea>
        <div class="helper-text">
          Please provide as much detail as possible. Reports are confidential.
        </div>
        <button
          class="button2-box send-btn"
          :disabled="!localReportText.trim()"
          @click="onSend"
        >Send Report</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, ref } from "vue";
const props = defineProps({
  show: Boolean,
  disabled: Boolean,
  reportText: String,
});
const emit = defineEmits(["close", "send", "update:report-text"]);

const localReportText = ref(props.reportText || "");

watch(() => props.reportText, (val) => {
  localReportText.value = val || "";
});

function onClose() {
  emit("close");
}
function onSend() {
  emit("send", localReportText.value);
}
watch(localReportText, (val) => {
  emit("update:report-text", val);
});
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
   z-index: 6000;
  font-family: 'Inter', 'Segoe UI', Arial, sans-serif;
}
.modal-card {
  width: 420px;
  max-width: 96vw;
  padding: 32px 28px 26px 28px;
  background: #fff;
  border-radius: 18px;
  position: relative;
  animation: fadeInUp .28s cubic-bezier(.23,1.01,.32,1);
  box-shadow: 0 8px 32px rgba(0,0,0,0.18), 0 1.5px 6px rgba(0,0,0,0.08);
  border: 1.5px solid #f3f4f6;
}
.modal-header {
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: 12px;
  justify-content: flex-start;
}
.modal-title {
  font-size: 22px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  letter-spacing: 0.01em;
  text-align: left;
}
.details-row {
  display: flex;
  justify-content: flex-start;
  margin: 10px 0 6px 0;
}
.label {
  font-weight: 600;
  color: #444;
  font-size: 15px;
}
.close-icon {
  position: absolute;
  top: 16px;
  right: 16px;
  border: none;
  background: none;
  cursor: pointer;
  padding: 4px;
  transition: background 0.15s;
  border-radius: 50%;
}
.close-icon:hover {
  background: #f3f4f6;
}
.report-textarea {
  width: 100%;
  min-height: 90px;
  border-radius: 10px;
  border: 1.5px solid #e5e7eb;
  padding: 12px;
  font-size: 15.5px;
  resize: vertical;
  margin-top: 2px;
  margin-bottom: 0;
  box-sizing: border-box;
  background: #f9fafb;
  transition: border 0.18s;
  text-align: left;
}
.report-textarea:focus {
  outline: none;
  border-color: #2563eb;
  background: #fff;
}
.helper-text {
  font-size: 13px;
  color: #64748b;
  margin: 7px 0 0 2px;
  line-height: 1.4;
}
.send-btn {
  width: 100%;
  min-width: 0;
  padding: 10px 0;
  font-size: 16px;
  font-weight: 600;
  border-radius: 9px;
  margin-top: 22px;
  background: linear-gradient(90deg, #2563eb 60%, #1746a2 100%);
  color: #fff;
  border: none;
  transition: background 0.18s, box-shadow 0.18s;
  box-shadow: 0 2px 8px rgba(37,99,235,0.08);
  letter-spacing: 0.01em;
}
.send-btn:disabled {
  background: #cbd5e1;
  color: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.85;
  box-shadow: none;
}
.send-btn:not(:disabled):hover {
  background: linear-gradient(90deg, #1746a2 60%, #2563eb 100%);
  box-shadow: 0 2px 12px rgba(37,99,235,0.13);
}
@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(24px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}
@media (max-width: 500px) {
  .modal-card {
    min-width: 90vw;
    padding: 18px 6vw 18px 6vw;
  }
  .modal-header {
    gap: 7px;
  }
}
</style>
